import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import { setRowSize } from 'utils';

type Props = {
  values: any;
  disabled: boolean;
  setFieldValue: (arg1: string, arg2: string) => void;
  errors: any;
};

const IProvidedInformationContainer = ({ values, disabled, errors, setFieldValue }: Props) => {
  const getContainerContent = () => {
    const inputText = values.chemicalRiskAttributes.providedDetails || '';
    const rows = setRowSize(inputText, 2, 90);

    return (
      <Grid stackable columns={1} verticalAlign="bottom">
        <GridColumnInputWrapper
          fieldClassName="checkboxInline checkboxMargin"
          inputClassName="left-floated"
          displayLabelAfter={true}
          labelClassName="checkboxLabelOnRight"
          value={values.chemicalRiskAttributes.providedTrainingCourse}
          name="chemicalRiskAttributes.providedTrainingCourse"
          label="inventory.details.page.provided.inf.container.provided.training.course"
          type="checkbox"
          disabled={disabled}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          render={(props: any) => <InputWrapper {...props} />}
        />
        <GridColumnInputWrapper
          fieldClassName="checkboxInline checkboxMargin"
          inputClassName="left-floated"
          displayLabelAfter={true}
          labelClassName="checkboxLabelOnRight"
          value={values.chemicalRiskAttributes.providedInformation}
          name="chemicalRiskAttributes.providedInformation"
          label="inventory.details.page.provided.inf.container.provided.information"
          type="checkbox"
          disabled={disabled}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          render={(props: any) => <InputWrapper {...props} />}
        />
        <GridColumnInputWrapper
          rows={rows}
          value={inputText}
          name="chemicalRiskAttributes.providedDetails"
          label="inventory.details.page.provided.inf.container.provided.details"
          type="textarea"
          disabled={disabled}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          render={(props: any) => <InputWrapper {...props} />}
        />
      </Grid>
    );
  };

  return (
    <AccordionWrapper
      accordionTitle="inventory.details.page.provided.inf.container.title"
      className="containerReducedWhiteSpace"
      render={getContainerContent}
    />
  );
};

export default IProvidedInformationContainer;
